import { OfferBrief } from '../public_api';

export type Country = {
  name: string;
  code: string;
  countryCode: number;
};

export type CountryRegion = {
  name: string;
  code: string;
};

export enum LocationsScope {
  Active = 'active',
  Archived = 'archived',
}

export interface LocationTranslation {
  default: boolean;
  langCode: string;
  name: string;
  note: string;
  postalCode: string;
  city: string;
  street: string;
  fullAddress: string;
  filledCount: number;
  totalCount: number;
}

export interface LocationBrief {
  id: number;
  langCode: string;
  countryCode: string;
  stateCode: string;
  name: string;
  note: string;
  postalCode: string;
  city: string;
  street: string;
  fullAddress: string;
  createdAt: string;
  updatedAt: string;
  archivedAt: string;
}

export interface Location extends LocationBrief {
  offersCount?: number;
  translations?: { [key: string]: LocationTranslation };
}

export interface LocationsCounters {
  active: number;
  archived: number;
}

export type LocationJobsResponse = {
  offers: Array<Pick<OfferBrief, 'id' | 'title' | 'slug' | 'status' | 'locationIds'>>;
};
